
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns180fda441a9c755432801435c5e61665en from './en.yaml'
            i18n.addResourceBundle('en', '180fda441a9c755432801435c5e61665', flattenObject(ns180fda441a9c755432801435c5e61665en), true, true);
        
        export default '180fda441a9c755432801435c5e61665';
    